﻿import 'jquery';
import 'popper.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import '@fortawesome/fontawesome-free/css/all.css';
import '../src/assets/styles/site-fonts.css';

import Vue from 'vue';
import App from './App.vue';


Vue.config.productionTip = true;

new Vue({
    render: h => h(App)
}).$mount('#app');
